import DataBreachHistoricWriteModel
  from '@/domain/dataBreach/historic/DataBreachHistoricWriteModel';
import DataBreachHistoricCache from '@/infrastructure/dataBreach/historic/DataBreachHistoricCache';

export default class DataBreachHistoricWriteModelApi implements DataBreachHistoricWriteModel {
  async reset(): Promise<void> {
    await DataBreachHistoricCache.reset();
  }
}
